// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { closePopup } from '../../../../../components/popupPanel/popupActions';
import { pushSuggestionPopupShown } from './pushSuggestionActions';

// Components
import PopupPanel from '../../../../../components/popupPanel/PopupPanel';
import PushNotificationsSuggestionPopup from './PushNotificationsSuggestionPopup';

// Constants
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

const mapDispatchToProps = (dispatch) => ({
    dispatchPushSuggestionPopupShown: () => dispatch(pushSuggestionPopupShown()),
    dispatchClosePopup: () => dispatch(closePopup(PopupIds.PUSH_SUGGESTION, false)),
});

@connect(null, mapDispatchToProps)
class PushNotificationsSuggestionPopupContainer extends React.Component {
    onClose = () => {
        const { dispatchPushSuggestionPopupShown, dispatchClosePopup } = this.props;
        dispatchPushSuggestionPopupShown();
        dispatchClosePopup();
    };

    render() {
        return (
            <PopupPanel popupId={PopupIds.PUSH_SUGGESTION} className="PushNotificationsSuggestionPopup">
                <PushNotificationsSuggestionPopup onClose={this.onClose} />
            </PopupPanel>
        );
    }
}

PushNotificationsSuggestionPopupContainer.propTypes = {
    showSuggestionsPopup: PropTypes.bool,
    dispatchPushSuggestionPopupShown: PropTypes.func,
    dispatchClosePopup: PropTypes.func,
};

export default PushNotificationsSuggestionPopupContainer;
